import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import pluralize from 'pluralize';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { saveAs } from 'file-saver';
import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';
import {showError, isViewerUser} from '../../helpers';
import {Link} from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import {TableCell, TableContainer} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import IconButton from '@material-ui/core/IconButton';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const pairingStatusStr = ['Unknown', 'Unpaired', 'Paired'];

const dateTimeFormat = 'YYYY-MM-DD HH:mm';

const InfrastructureExpanded = (props) => {
  const { vc_allocated_ports = [], ra_allocated_ports = [], version = {}, vc_port_range = {}, ra_port_range = {}, server_port = '', vcs =[], nodes = [], status = {}, server_path = '' } = props;
  const [description, setDescription] = useState(props.description || '');
  const [serverPort, setServerPort] = useState(server_port);
  const [vcPortStart, setVcPortStart] = useState(vc_port_range.start);
  const [vcPortEnd, setVcPortEnd] = useState(vc_port_range.end);
  const [raPortStart, setRaPortStart] = useState(ra_port_range.start);
  const [raPortEnd, setRaPortEnd] = useState(ra_port_range.end);
  const [edit, setEdit] = useState(false);
  const [vcReset, setVcReset] = useState(false);
  const [raReset, setRaReset] = useState(false);
  const [vcExtendError, setVcExtendError] = useState(false);
  const [raExtendError, setRaExtendError] = useState(false);
  const [serverPath, setServerPath] = useState(server_path);
  const [isViewVirtualCameras, setViewVirtualCameras] = useState(false);
  const [isViewDevice, setViewDevice] = useState(false);

  function staticTextField (label, value='-') {
    return (
      <div>
        <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={true}>
          <ListItemText primary={label} secondary={value} />
        </ListItem>
        <Divider />
      </div>
    );
  }

  function isSaveDisable () {
    return (
      ((description === props.description) &&
      (serverPort === server_port) &&
      (serverPath === server_path) &&
      (vcPortStart === vc_port_range.start) &&
      (vcPortEnd === vc_port_range.end) &&
      (raPortStart === ra_port_range.start) &&
      (raPortEnd === ra_port_range.end)) ||
      vcExtendError ||
      raExtendError
    );
  }

  function onSave () {
    const { id } = props;
    const promises = [];
    let port = {};
    let isPortChanged = false;
    if ((description !== props.description) || (serverPort !== server_port) || (serverPath !== server_path)) {
      promises.push(AppActions.updateInfrastructure(id, { description, server_port: serverPort, server_path: serverPath }));
    }
    if ((vcPortStart !== vc_port_range.start) || (vcPortEnd !== vc_port_range.end)) {
      port.vc_port_range = { start: parseInt(vcPortStart), end: parseInt(vcPortEnd) };
      isPortChanged = true;
    }
    if ((raPortStart !== ra_port_range.start) || (raPortEnd !== ra_port_range.end)) {
      port.ra_port_range = { start: parseInt(raPortStart), end: parseInt(raPortEnd) };
      isPortChanged = true;
    }
    if (isPortChanged) {
      promises.push(AppActions.updateInfrastructurePort(id, port));
    }
    Promise.all(promises)
      .then(() => {
        ReactDOM.unstable_batchedUpdates(() => {
          setEdit(false);
          setVcReset(false);
          setRaReset(false);
          props.onUpdate({ id, description, server_port: serverPort, server_path: serverPath, ...port });
        });
        AppActions.setSnackbar(`'${props.name}' infrastructure updated successfully`);
      })
      .catch(err => showError(err, `Update '${props.name}' Infrastructure failed`));
  }

  function onCancel () {
    setDescription(props.description);
    setServerPort(server_port);
    setServerPath(server_path);
    setVcPortStart(vc_port_range.start);
    setVcPortEnd(vc_port_range.end);
    setRaPortStart(ra_port_range.start);
    setRaPortEnd(ra_port_range.end);
    setEdit(false);
    setVcReset(false);
    setRaReset(false);
    setVcExtendError(false);
    setRaExtendError(false);
  }

  function onDownload () {
    const org = AppStore.getOrganization() || {};
    const tenantName = org.name || '';
    const url = window.location.origin || '';
    const downloadValues = {
      type: props.type,
      api_key: props.api_key,
      ewm_url: url,
      ewc: {
        domain_name: props.domain_name || '',
        instance_id: props.instance_id,
        hosted_by: props.hosted_by,
        server_port: props.server_port,
      },
      proxy_info: {
        type: props.proxyInfo?.type || '',
        url: props.proxyInfo?.url || '',
        port: props.proxyInfo?.port || '',
        auth: props.proxyInfo?.auth || '',
        user_name: props.proxyInfo?.user_name || '',
        password: props.proxyInfo?.password || '',
        protocol: props.proxyInfo?.protocol || '',
        timeout: props.proxyInfo?.timeout || '',
        retries: props.proxyInfo?.retries || '',
        whitelist_urls: props.proxyInfo?.whitelist_urls || []
      }
    };
    var blob = new Blob([JSON.stringify(downloadValues)], { type: 'text/json;charset=utf-8' });
    saveAs(blob, `ewc_config_${tenantName}_${props.name}.json`);
  }

  function r1Action () {
    return (
      <Grid item xs={12}>
        <Box display='flex' justifyContent='flex-end'>
          <Button variant='contained' color='primary' onClick={onDownload}>Download</Button>
        </Box>
      </Grid>
    );
  }

  function onRaExtend (e) {
    const value = e.target.value;
    if (!value) {
      setRaExtendError(false);
      setRaPortEnd(ra_port_range.end);
    } else if (Number.isNaN(value * 1)) {
      setRaExtendError(true);
      setRaPortEnd(ra_port_range.end);
    } else {
      setRaExtendError(false);
      setRaPortEnd(parseInt(ra_port_range.end) + parseInt(value));
    }
  }

  function onRaReset () {
    setRaReset(true);
    setRaPortStart(0);
    setRaPortEnd(0);
  }

  function onVcExtend (e) {
    const value = e.target.value;
    if (!value) {
      setVcExtendError(false);
      setVcPortEnd(vc_port_range.end);
    } else if (Number.isNaN(value * 1)) {
      setVcExtendError(true);
      setVcPortEnd(vc_port_range.end);
    } else {
      setVcExtendError(false);
      setVcPortEnd(parseInt(vc_port_range.end) + (parseInt(value) * 2));
    }
  }

  function onVcReset () {
    setVcReset(true);
    setVcPortStart(0);
    setVcPortEnd(0);
  }

  function row2Actions () {
    return (
      <Grid item xs={12}>
        <Grid container alignItems='center'>
          <Grid item xs={3}>
            <Button variant='contained' color='primary' disabled={true} onClick={() => setEdit(true)}>Edit</Button>
          </Grid>
          <Grid item xs={3}>
            {
              vc_allocated_ports.length
                ? (
                  <TextField disabled variant='filled' label='Extend By Number of VC' onChange={onVcExtend} error={vcExtendError} style={{ marginTop: 0 }} helperText='Please Enter value in number'  />
                )
                : (
                  <Button variant='contained' color='primary' disabled={true} onClick={onVcReset}>Reset</Button>
                )
            }
          </Grid>
          <Grid item xs={3}>
            {
              ra_allocated_ports.length
                ? (
                  <TextField variant='filled' label='Extend By Number of RA' onChange={onRaExtend} error={raExtendError} style={{ marginTop: 0 }}
                    helperText='Please Enter value in number' />
                )
                : (
                  <Button variant='contained' color='primary' disabled={true} onClick={onRaReset}>Reset</Button>
                )
            }
          </Grid>
          <Grid item xs={3}>
            <Box display='flex' justifyContent='flex-end'>
              <Box mr={1}>
                <Button variant='contained' onClick={onCancel}>Cancel</Button>
              </Box>
              <Button variant='contained' color='primary' disabled={isSaveDisable()} onClick={onSave}>Save</Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function row2C3 () {
    return (
      <Grid item xs={3}>
        <Box mb={2}>
          <TextField variant='filled' label='RA Port Start' value={raPortStart} disabled={!raReset} onChange={e => setRaPortStart(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
        <Box mb={2}>
          <TextField variant='filled' label='RA Port End' value={raPortEnd} disabled={!raReset} onChange={e => setRaPortEnd(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
      </Grid>
    );
  }

  function row2C2 () {
    return (
      <Grid item xs={3}>
        <Box mb={2}>
          <TextField variant='filled' label='VC Port Start' value={vcPortStart} disabled={!vcReset} onChange={e => setVcPortStart(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
        <Box mb={2}>
          <TextField variant='filled' label='VC Port End' value={vcPortEnd} disabled={!vcReset} onChange={e => setVcPortEnd(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
      </Grid>
    );
  }

  function row2C1 () {
    return (
      <Grid item xs={3}>
        <Box mb={2}>
          <TextField variant='filled' label='Server Port' value={serverPort} disabled={!edit} onChange={ e => setServerPort(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
        <Box mb={2}>
          <TextField variant='filled' label='Description' value={description} disabled={!edit} onChange={ e => setDescription(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
        <Box mb={2}>
          <TextField variant='filled' label='Server Path' value={serverPath} disabled={!edit} onChange={ e => setServerPath(e.target.value)}
            style={{ marginTop: 0 }} />
        </Box>
      </Grid>
    );
  }

  function row2 () {
    return (
      <Grid container>
        {row2C1()}
        {row2C2()}
        {row2C3()}
        {!isViewerUser() ? row2Actions() : null }
      </Grid>
    );
  }

  function row1 () {
    const pairingTime = props.pairing_ts ? moment(props.pairing_ts).format(dateTimeFormat) : '-';
    const updatedTime = moment(props.updated_ts).format(dateTimeFormat);
    const upTime = status.uptime ? moment(parseInt(status.uptime) * 1000).format(dateTimeFormat) : '-';
    const { error = {} } = status;
    const freeVcPort = vcPortEnd - vcPortStart - vc_allocated_ports.length;
    const freeRaPort = raPortEnd - raPortStart - ra_allocated_ports.length;

    return (
      <>
        <List className="list-horizontal-flex">
          {staticTextField('Name', props.name)}
          {staticTextField('Domain', props.domain_name)}
          {staticTextField('Host Mode', props.hosted_by)}

          {staticTextField('Instance ID', props.instance_id)}
          {staticTextField('Pairing Status', pairingStatusStr[props.pairing_status])}
          {staticVirtualCameraText('VCs', vcs)}
          {isViewVirtualCameras ? showDropDownList(vcs, ['#', 'Virtual Camera'], '/vcam') : null}

          {staticDevicesText('Nodes', nodes)}
          {staticTextField('Software Version',version.software)}
          {staticTextField('Protocol Version', version.protocol)}
          {isViewDevice ? showDropDownList(nodes, ['#', 'Nodes'], '/devices') : null}

          {staticTextField('Updated Time', updatedTime)}
          {staticTextField('Pairing Time', pairingTime)}
          {props.multicast_ip_start ? staticTextField('Multicast IP start', props.multicast_ip_start) : null}
          {props.multicast_port ? staticTextField('Multicast Port', props.multicast_port) : null}
          {staticTextField('IP Address', props.ip_addr || '-')}
          {staticTextField('User Name', props.username)}
          {staticTextField('Password', props.password)}
          {staticTextField(`Free VC ${pluralize('Port', freeVcPort)}`, freeVcPort)}
          {staticTextField(`Free RA ${pluralize('Port', freeRaPort)}`, freeRaPort)}
          {staticTextField('Up Time', upTime)}
          {staticTextField('Status', status.status || '-')}
          {staticTextField('Error State', error.state || '-')}
          {staticTextField('Error Msg', error.msg || '-')}
          {staticTextField('Api Key', props.api_key)}
        </List>
        <Grid container>
          {r1Action()}
        </Grid>
      </>
    );
  }

  function staticDevicesText(label, values) {
    const onclick = () => {
      setViewDevice(!isViewDevice);
      setViewVirtualCameras(false);
    }
    return staticDropDownText(label, values, isViewDevice, onclick);
  }

  function staticVirtualCameraText(label, values) {
    const onclick = () => {
      setViewVirtualCameras(!isViewVirtualCameras);
      setViewDevice(false);
    }
    return staticDropDownText(label, values, isViewVirtualCameras, onclick);
  }

  function staticDropDownText(label, values, isSelected, onclick) {
    let count = values !== undefined ? values.length : 0;
    return (
      <div>
        <ListItem selected={isSelected} classes={{ root: 'attributes', disabled: 'opaque' }}>
          <ListItemText primary={label} secondary={count} />
          <IconButton style={{opacity: 1}} onClick={() => onclick()}>
            {isSelected ? <ExpandLess/> : <ExpandMore />}
          </IconButton>
        </ListItem>
        <Divider />
      </div>
    );
  }

  function showDropDownList(list, headerNames, link) {
    const viewBody = function (item, index) {
      return (
        <TableRow key={index}>
          {createDefaultTableBodyCell(index)}
          {createLinkTableBodyCell(item, link)}
        </TableRow>
      );
    }
    return createTable(headerNames, viewBody, list);
  }

  function createDefaultTableBodyCell(value, minWidth) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth}
    return getTableCell(value, cellStyle);
  }

  function createLinkTableBodyCell(value, path) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', color: 'red'}
    return (
      <Link to={path} underline="none" onClick={() => props.updateRedirect({id: value})}>
        {getTableCell(value, cellStyle)}
      </Link>
    );
  }

  function getTableCell(value, style) {
    return (
      <TableCell style={style}>
        {getCellValue(value)}
      </TableCell>
    );
  }

  function getCellValue(value) {
    let finalValue;
    if(value !== undefined && value !== null && value !== '')
      finalValue = typeof value === 'number' ? value + 1 : value;
    else
      finalValue = '-';
    return finalValue;
  }

  function createTable(headerNames, viewBody, dataRow) {
    return(
      <div className='border' style={{minWidth: '100%'}}>
        <TableContainer>
          <Table>
            {createTableHeader(headerNames)}
            <TableBody style={{opacity: 0.5}}>
              {dataRow.map((item, index) => viewBody(item, index))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }

  function createTableHeader(names) {
    return (
      <TableHead>
        <TableRow>
          {names.map(name => createTableHeaderCell(name))}
        </TableRow>
      </TableHead>
    );
  }

  function createTableHeaderCell(value) {
    return (
      <TableCell style={{fontWeight: 'bold', paddingBottom: '15px', paddingTop: '15px'}}>
        {value}
      </TableCell>
    );
  }

  return (
    <div className='infrastructure-expanded'>
      <div className='border'>{row1()}</div>
      <div className='row border'>{row2()}</div>
    </div>
  );
};

InfrastructureExpanded.propTypes = {
  id: PropTypes.string.isRequired,
  instance_id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  pairing_status: PropTypes.number.isRequired,
  vc_allocated_ports: PropTypes.array.isRequired,
  ra_allocated_ports: PropTypes.array.isRequired,
  version: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  domain_name: PropTypes.string.isRequired,
  //region: PropTypes.string.isRequired,
  server_port: PropTypes.string.isRequired,
  description: PropTypes.string,
  vc_port_range: PropTypes.object,
  ra_port_range: PropTypes.object,
  public_ip: PropTypes.string,
  private_ip: PropTypes.string,
  username: PropTypes.string,
  password: PropTypes.string,
  status: PropTypes.object,
  server_path: PropTypes.string
};

InfrastructureExpanded.defaultProps = {
  description: ''
};

export default React.memo(InfrastructureExpanded);
